<template>
  <div class="steps">
    <div class="steps-timeline">
      <span class="line" :style="`width: ${answerPercentage}%;`"></span>
      <template v-for="(step, key) in this.steps">
        <span class="single-step" :class="currentStep >= key ? 'active' : ''">
          <span class="step-label sd-title">{{ step }}</span>
        </span>
      </template>
    </div>
    <svg-icon :style="iconPos" icon="superhero"></svg-icon>
  </div>
</template>
<style scoped>
  .steps {
    position: relative;
    margin: 0 25px 50px;
  }

  .steps .steps-timeline {
    display: flex;
    justify-content: space-between;
    width: 100%;
    position: relative;
  }

  .steps .steps-timeline::after {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 8px;
    content: '';
    display: block;
    background-color: rgba(255, 189, 0, .5);
    width: 100%;
    height: 3px;
    z-index: 0;
  }

  .steps .steps-timeline .line {
    display: block;
    background-color: #FFCD00;
    height: 3px;
    position: absolute;
    bottom: 8px;
  }

  .steps .single-step {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 25px;
  }

  .steps .single-step .step-label {
    position: absolute;
    top: -10px;
    white-space: nowrap;
  }

  .steps .single-step::after {
    content: '';
    display: block;
    border: 2px solid rgba(255, 189, 0, .5);
    background-color: #FFF;
    width: 20px;
    height: 20px;
    border-radius: 100%;
    z-index: 1;
  }

  .steps .single-step.active::after {
    background-color: #FFCD00;
    border-color: #FFCD00;
  }

  .steps .svg-container {
    position: absolute;
    width: 60px;
    height: 15px;
    bottom: 2px;
    background-color: #FFF;
    color: #FFCD00;
    padding: 0 10px;
  }

  @media screen and (max-width: 360px) {
    .steps .single-step .step-label {
      font-size: 12px;
    }
  }
</style>

<script>
export default {
  data: function() {
    return {
      answerPercentage: '',
      startPercentage: '',
      iconPos: '',
    }
  },
  props: {
    steps: {
      type: Object,
      default: () => ({}),
    },
    totalAnswered: {},
    currentStep: {
      type: String
    }
  },
  mounted: function() {
    this.startPercentage = ((this.currentStep - 1) * 100) / (Object.keys(this.steps).length - 1);
    this.answerPercentage = this.totalAnswered/Object.keys(this.steps).length + this.startPercentage;
  },
  updated: function() {
    this.startPercentage = ((this.currentStep - 1) * 100) / (Object.keys(this.steps).length - 1);
    this.answerPercentage = this.totalAnswered/(Object.keys(this.steps).length-1) + this.startPercentage;

    this.iconPos = 'left: calc('+this.answerPercentage+'% - '+(this.startPercentage !== 0 ? (50*(this.totalAnswered/100))+'px' : '25px')+')';
  }
};
</script>